import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import type { AppProps } from '../common/types';
import PortalSettingsHeader from './portal-settings-header';
import PortalTabs from './portal-tabs';

const PortalSettings = (props: AppProps) => (
	<>
		<PageWrapper>
			<PortalSettingsHeader projectKey={props.projectKey} projectName={props.projectName} />
			<PortalTabs {...props} />
		</PageWrapper>
		<SpaStatePageReady />
	</>
);

export default PortalSettings;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PageWrapper = styled.div({
	/* Content width is 600px. Tabs have a horizontal padding of 8px we want that space back */
	width: '616px',
	margin: `${token('space.200', '16px')} auto 0 auto`,
	padding: `0 ${token('space.300', '24px')}`,
});
